<template>
  <offer-layout class="additionalUploader">
    <div class="additionalUploaderContent">
      <illion-adr-uploader
        class="adrUploader"
        :application="application"
        :updateApplicationWithStore="updateApplicationWithStore"
      >
        <template #illion-statement-uploader-header>
          <heading level="2" class="heading">{{ t('title.illion') }}</heading>
        </template>

        <template #illion-statement-uploader-online-tab-content>
          <div class="electronicVerification">
            <faq-modal v-if="showFAQModal" @close="triggerModal" />
            <p class="heading">{{ t('electronicVerification.title') }}</p>
            <p class="description" v-for="(simpleStep, index) in simpleSteps" :key="index">
              {{ simpleStep }}
            </p>
            <div class="hintBox">
              <brand-link @click="triggerModal" class="hint">
                <span class="hintText">{{ t('electronicVerification.questions') }}</span>
              </brand-link>
            </div>
          </div>
        </template>

        <template #illion-flow-consents>
          <consents
            :pageConsents="bankStatementConsents"
            :consentsPath="consentsPath"
            v-model="application.consents"
          />
        </template>

        <template #adr-uploader-header>
          <div class="adrHeader">
            <heading level="2">{{ $t('additionalDataUploader.title.adr') }}</heading>
            <p>{{ $t('additionalDataUploader.subtitle.adr') }}</p>
          </div>
        </template>
      </illion-adr-uploader>
    </div>
  </offer-layout>
</template>
<script>
import { mapActions } from 'vuex';
import IllionAdrUploader from '@/components/illionComponents/IllionAdrUploader';
import buildTranslators from '@/utils/build-translators';
import Consents from '@/components/Consents';
import bankStatementConsents from '@/modules/bank-statement-consents';
import FaqModal from '@/components/FaqModal';

import OfferLayout from '@/views/layouts/OfferLayout';
import applicationMixin from '@/mixins/application';

export default {
  name: 'application-dashboard',
  components: {
    OfferLayout,
    IllionAdrUploader,
    Consents,
    FaqModal,
  },
  data() {
    return {
      errorMessage: '',
      showFAQModal: false,
      simpleSteps: [
        this.t('electronicVerification.description.firstStep'),
        this.t('electronicVerification.description.secondStep'),
        this.t('electronicVerification.description.thirdStep'),
      ],
      bankStatementConsents,
    };
  },
  computed: {
    consentsPath() {
      return 'additionalDataUploader.electronicVerification.consents';
    },
  },
  methods: {
    t(key, options) {
      return buildTranslators('additionalDataUploader').t(key, options);
    },
    triggerModal() {
      this.showFAQModal = !this.showFAQModal;
    },
  },
  mixins: [applicationMixin],
};
</script>
<style lang="sass" scoped>
.additionalUploaderContent
  display: flex
  justify-content: center
  padding-bottom: baseunit(22)

.adrUploader
  width: 100%
  +mq($tyranno)
    max-width: baseunit(68)

.electronicVerification
  width: 100%
  display: flex
  flex-direction: column
  justify-content: center
  color: $ebs-text-color

  .heading
    +font-size(13.33, 20)
    font-weight: bold
    line-height: $glass-spacing-3
    margin-top: 0

  .description
    +font-size(13.33, 20)
    margin: 0
    margin-top: $glass-spacing-05
    color: $color-system-neutral-gray-5

  .hintBox
    border-bottom: 1px solid $color-system-neutral-gray-3
    padding-bottom: $glass-spacing-105
    margin: $glass-spacing-2 0 $glass-spacing-2

  .hint
    +font-size(13.33, 16)
    cursor: pointer

    .hintText
      color: $brand-link-partner-color
      text-decoration: underline;
      font-weight: bold

.adrHeader
  text-align: center
</style>
